var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndexedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2875 2.55016C13.0542 1.54183 11.5292 0.875163 9.85417 0.708496V2.39183C11.0708 2.54183 12.1792 3.02516 13.1042 3.74183L14.2875 2.55016ZM15.6292 8.16683H17.3125C17.1458 6.49183 16.4792 4.96683 15.4708 3.7335L14.2792 4.91683C14.9958 5.84183 15.4792 6.95016 15.6292 8.16683ZM14.2792 13.0835L15.4708 14.2752C16.4792 13.0418 17.1458 11.5085 17.3125 9.84183H15.6292C15.4792 11.0502 14.9958 12.1585 14.2792 13.0835ZM9.85417 15.6085V17.2918C11.5292 17.1252 13.0542 16.4585 14.2875 15.4502L13.0958 14.2585C12.1792 14.9752 11.0708 15.4585 9.85417 15.6085ZM9.85417 9.00016V4.8335H8.1875V9.00016H4.85417L9.02083 13.1668L13.1875 9.00016H9.85417ZM8.1875 15.6085V17.2918C3.97917 16.8752 0.6875 13.3252 0.6875 9.00016C0.6875 4.67516 3.97917 1.12516 8.1875 0.708496V2.39183C4.89583 2.80016 2.35417 5.60016 2.35417 9.00016C2.35417 12.4002 4.89583 15.2002 8.1875 15.6085Z",
    fill: "#8596B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexedIcon);
export default __webpack_public_path__ + "static/media/indexed-icon.572966c93baa92df1db79b1f3b43774e.svg";
export { ForwardRef as ReactComponent };